var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:_vm.videoPlayerRef,staticStyle:{"width":"100%","height":"100%"},attrs:{"muted":"muted"},domProps:{"muted":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }